import {
  getExtendedErrorText,
  mainApi,
  queryFnNotifyWrapper,
} from 'modules/api';
import { IWithConnectionKeyParams } from 'modules/api/types';
import { authCacheTags } from 'modules/auth/authCacheTags';
import { getConnectedIotaProvider } from 'modules/auth/utils/getConnectedIotaProvider';

export const {
  useGetAccountsQuery,
  endpoints: { getAccounts },
} = mainApi.injectEndpoints({
  endpoints: build => {
    return {
      getAccounts: build.query<string[], IWithConnectionKeyParams>({
        queryFn: queryFnNotifyWrapper<
          IWithConnectionKeyParams,
          never,
          string[]
        >(
          () => {
            const provider = getConnectedIotaProvider();

            return Promise.resolve({ data: provider.getAccounts() });
          },
          error => getExtendedErrorText(error, 'Failed to get accounts'),
        ),
        providesTags: [authCacheTags.account],
      }),
    };
  },
});
